/* eslint-disable react/no-unused-state */
/* global window */
import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import DOM from './assetView';
import {
    getTodayEndInServerFormat,
    getTodayStartInServerFormat,
    getYesterdayInServerFormat,
    getTodayInServerFormat,
} from '../../core/utils/dateUtils';
import * as driverActions from '../../core/driver/driverActions';
import * as assetActions from '../../core/asset/assetActions';
import * as reportActions from '../../core/report/reportActions';
import { triggerErrorNotification } from '../../core/utils/notificationUtils';
import { fetchApiAuth } from '../../core/utils/api';

const { DB_DATE_FORMAT } = require('../../core/constants').default;

class AssetView extends React.PureComponent {
    constructor(props) {
        super(props);
        this.view = DOM;
        this.googleMapAccess = React.createRef();

        this.state = {
            currentTabKey: '1',

            // --- Asset Journeys ---
            assetJourneyTabLoaded: false,
            assetJourneyTabFilter: {
                date_from: getTodayStartInServerFormat(),
                date_to: getTodayEndInServerFormat(),
                driver: [],
                is_authorised: 'all',
                journey_event: 'all',
                page: 1,
            },
            assetJourneys: [],
            assetJourneysPagination: {
                currentPage: 1,
                perPageCount: 10,
                totalRecords: 0,
            },
            isLoadingAssetJourneys: false,
            isExportingAssetJourneyCsv: false,

            // --- Asset Events ---
            eventHistoryTabLoaded: false,
            assetEventTabFilter: {
                date_from: getTodayStartInServerFormat(),
                date_to: getTodayEndInServerFormat(),
                event_type: 'all',
                driver: [],
                division: '',
                postcode: '',
                miles: '',
                page: 1,
            },
            assetEvents: [],
            assetEventsPagination: {
                currentPage: 1,
                perPageCount: 10,
                totalRecords: 0,
            },
            isLoadingAssetEvents: false,
            isExportingAssetEventHistoryCsv: false,

            videoHistoryTabLoaded: false,
            videoHistoryTabFilter: {
                date_from: getYesterdayInServerFormat(),
                date_to: getTodayInServerFormat(),
            },
            serviceAlertsTabLoaded: false,

            deleteDataConfirmButtonVisible: false,
            isDeleteDataModalVisible: false,
            deleteDataModalInput: null,
            displayFilter: true,
        };
    }

    componentDidMount() {
        const { match, driverList, actions, assetViewJourneyFilters } = this.props;
        const { asset_id } = match.params;

        // Basic fetch
        actions.getAssetInfoRequest(asset_id);
        if (driverList.length <= 0) {
            actions.getDriverListRequest();
        }
        let params = {
            asset_id: [asset_id],
            ...this.state.assetJourneyTabFilter,
        }
        if (assetViewJourneyFilters?.length) {
            const matches = assetViewJourneyFilters.filter(f => parseInt(f.assetId) === parseInt(asset_id));
            if (matches?.length) {
                params = matches[0].filters;
            }
        }
        this.getAssetJourneys(params);
    }

    componentDidUpdate(prevProps) {
        const { singleAsset } = this.props;
        if (this.googleMapAccess && this.googleMapAccess.current) {
            const gooleInnerMap = this.googleMapAccess.current?.state.map;
            if (gooleInnerMap !== null) {
                gooleInnerMap.panTo({
                    lat: parseFloat(singleAsset.lat),
                    lng: parseFloat(singleAsset.lon),
                });
                gooleInnerMap.setZoom(13);
            }
        }
    }

    handleTabChange = (tabIndex) => {
        const { assetViewJourneyFilters, assetViewEventFilters } = this.props;
        
        if (tabIndex === '1') {
            this.setState({
                assetJourneys: [],
                isLoadingAssetJourneys: false,
                assetJourneyTabFilter: {
                    date_from: getTodayStartInServerFormat(),
                    date_to: getTodayEndInServerFormat(),
                    driver: [],
                    is_authorised: 'all',
                    journey_event: 'all',
                    page: 1,
                },
                currentTabKey: tabIndex
            }, () => {
                const { match } = this.props;
                const { asset_id } = match.params;
                let params = {
                    asset_id: [asset_id],
                    ...this.state.assetJourneyTabFilter,
                };
                if (assetViewJourneyFilters?.length) {
                    const matches = assetViewJourneyFilters.filter(f => parseInt(f.assetId) === parseInt(asset_id));
                    if (matches?.length) {
                        params = matches[0].filters;
                    }
                }
                this.getAssetJourneys(params);
            });

            return;
        }

        if (tabIndex === '2') {
            this.setState({
                assetEvents: [],
                isLoadingAssetEvents: false,
                assetEventTabFilter: {
                    date_from: getTodayStartInServerFormat(),
                    date_to: getTodayEndInServerFormat(),
                    event_type: 'all',
                    driver: [],
                    division: '',
                    postcode: '',
                    miles: '',
                    page: 1,
                },
                currentTabKey: tabIndex
            }, () => {
                const { match } = this.props;
                const { asset_id } = match.params;
                let params = {
                    assetId: asset_id,
                    ...this.convertAssetEventFilters(this.state.assetEventTabFilter),
                };
                if (assetViewEventFilters?.length) {
                    const matches = assetViewEventFilters.filter(f => parseInt(f.assetId) === parseInt(asset_id));
                    if (matches?.length) {
                        params = matches[0].filters;
                    }
                }
                this.getAssetEvents(params);
            });

            return;
        }

        // For all other tabs
        this.setState({ currentTabKey: tabIndex });
    };

    showModal = () => {
        this.setState({ isDeleteDataModalVisible: true });
    };

    saveDeleteText = (text) => {
        this.setState({ deleteDataModalInput: text });
        if (text.toLowerCase() === 'delete') {
            this.setState({ deleteDataConfirmButtonVisible: true });
        } else {
            this.setState({ deleteDataConfirmButtonVisible: false });
        }
    };

    handleOk = () => {
        const { deleteDataModalInput } = this.state;
        const { actions, singleAsset } = this.props;
        if (deleteDataModalInput && deleteDataModalInput.toLowerCase() === 'delete') {
            actions.deleteAssetDataRequest({ assetId: singleAsset.id });
        }
        this.setState({ isDeleteDataModalVisible: false });
    };

    handleCancel = () => {
        this.setState({
            isDeleteDataModalVisible: false,
            deleteDataModalInput: null,
        });
    };

    uploadImage = (data) => {
        const { actions, match } = this.props;
        const { asset_id } = match.params;
        actions.uploadAssetImageRequest({
            assetId: asset_id,
            image: data,
        });
    };

    assetJourneyTabLoaded = () => {
        this.setState({ assetJourneyTabLoaded: true });
    };

    async getAssetJourneys(params) {
        this.setState({ isLoadingAssetJourneys: true });

        params.asset_or_driver = 'assets';
        params.journey_or_day = 'journeys';
        params.per_page = 10;

        try {
            const response = await fetchApiAuth({
                method: 'GET',
                url: '/report/get-timesheet-report',
                params,
            });

            const { data, headers } = response;
            // read pagination from headers
            const total = parseInt(headers['x-pagination-total-count'] || '0', 10);
            const perPage = parseInt(headers['x-pagination-per-page'] || '10', 10);
            const current = parseInt(headers['x-pagination-current-page'] || '1', 10);

            this.setState({
                assetJourneys: data || [],
                assetJourneysPagination: {
                    currentPage: current,
                    perPageCount: perPage,
                    totalRecords: total,
                },
            });
        } catch (err) {
            triggerErrorNotification(err.response ? err.response.data.message : err.message);
        } finally {
            this.setState({ isLoadingAssetJourneys: false });
        }
    }

    eventHistoryTabLoaded = () => {
        this.setState({ eventHistoryTabLoaded: true });
    };

    onEventsTabFilterChange = (filterValues) => {
        const { match, actions } = this.props;
        const { asset_id } = match.params;
        const updatedFilter = { ...filterValues, page: 1 };

        this.setState({ assetEventTabFilter: updatedFilter }, () => {
            const params = {
                assetId: asset_id,
                ...this.convertAssetEventFilters(this.state.assetEventTabFilter),
            };
            actions.setAssetViewEventFilters({
                assetId: asset_id,
                filters: params,
            });
            this.getAssetEvents(params);
        });
    };

    onEventsHistoryTabPageChange = (page) => {
        const { match } = this.props;
        const { asset_id } = match.params;
        this.setState(
            (prevState) => ({
                assetEventTabFilter: {
                    ...prevState.assetEventTabFilter,
                    page,
                },
            }),
            () => {
                this.getAssetEvents({
                    assetId: asset_id,
                    ...this.convertAssetEventFilters(this.state.assetEventTabFilter),
                });
            }
        );
    };

    async getAssetEvents(params) {
        this.setState({ isLoadingAssetEvents: true });
        try {
            const { assetId, ...body } = params;

            const response = await fetchApiAuth({
                method: 'POST',
                url: `/asset/${assetId}/events`,
                params: { page: body.page || 1 },
                body,
            });

            const { data, headers } = response;
            const total = parseInt(headers['x-pagination-total-count'] || '0', 10);
            const perPage = parseInt(headers['x-pagination-per-page'] || '10', 10);
            const current = parseInt(headers['x-pagination-current-page'] || '1', 10);

            this.setState({
                assetEvents: data || [],
                assetEventsPagination: {
                    currentPage: current,
                    perPageCount: perPage,
                    totalRecords: total,
                },
            });
        } catch (err) {
            triggerErrorNotification(err.response ? err.response.data.message : err.message);
        } finally {
            this.setState({ isLoadingAssetEvents: false });
        }
    }

    videoHistoryTabLoaded = () => {
        this.setState({ videoHistoryTabLoaded: true });
    };

    serviceAlertsTabLoaded = () => {
        this.setState({ serviceAlertsTabLoaded: true });
    };

    // -------------------------
    // JOURNEY HISTORY TAB
    // -------------------------
    onJourneyHistoryTabPageChange = (page) => {
        const { match } = this.props;
        const { asset_id } = match.params;
        const { assetJourneyTabFilter } = this.state;

        const newFilter = { ...assetJourneyTabFilter, page };
        this.setState({ assetJourneyTabFilter: newFilter }, () => {
            this.getAssetJourneys({
                asset_id: [asset_id],
                asset_or_driver: 'assets',
                journey_or_day: 'journeys',
                ...this.convertAssetJourneyFilters(this.state.assetJourneyTabFilter),
            });
        });
    };

    onJourneyHistoryTabFilterChange = (filterValues) => {
        const { match, actions } = this.props;
        const { asset_id } = match.params;
        const updatedFilter = {
            ...filterValues,
            page: 1,
        };

        this.setState(
            { assetJourneyTabFilter: updatedFilter },
            () => {
                const params = {
                    asset_id: [asset_id],
                    asset_or_driver: 'assets',
                    journey_or_day: 'journeys',
                    ...this.convertAssetJourneyFilters(updatedFilter),
                };
                actions.setAssetViewJourneyFilters({
                    assetId: asset_id,
                    filters: params,
                });
                this.getAssetJourneys(params);
            }
        );
    };

    onJourneyHistoryTabSortChange = (pagination, filters, sorter) => {
        const { match } = this.props;
        const { asset_id } = match.params;

        const sortParams = {};
        if (sorter.field) {
            sortParams.field = sorter.field;
            sortParams.order = sorter.order === 'ascend' ? 'asc' : 'desc';
        }

        // Always reset to page=1 on sort
        const { assetJourneyTabFilter } = this.state;
        this.setState(
            {
                assetJourneyTabFilter: { ...assetJourneyTabFilter, page: 1 },
            },
            () => {
                this.getAssetJourneys({
                    asset_id: [asset_id],
                    asset_or_driver: 'assets',
                    journey_or_day: 'journeys',
                    ...this.convertAssetJourneyFilters(this.state.assetJourneyTabFilter),
                    ...sortParams,
                });
            }
        );
    };

    onJourneyEventsTabSortChange = (pagination, filters, sorter) => {
        const { match } = this.props;
        const { asset_id } = match.params;
        const orderBy = sorter.field ? `${sorter.order === 'descend' ? '-' : ''}${sorter.field}` : null;

        // Usually page resets to 1 on sort
        this.setState(
            (prev) => ({
                assetEventTabFilter: {
                    ...prev.assetEventTabFilter,
                    page: 1,
                },
            }),
            () => {
                this.getAssetEvents({
                    assetId: asset_id,
                    orderBy,
                    ...this.convertAssetEventFilters(this.state.assetEventTabFilter),
                });
            }
        );
    };

    convertAssetEventFilters = (filters) => {
        const out = { ...filters };
        // Convert date objects if needed
        if (out.date_from && typeof out.date_from === 'object') {
            out.date_from = out.date_from.format('YYYY-MM-DD 00:00:00');
        }
        if (out.date_to && typeof out.date_to === 'object') {
            out.date_to = out.date_to.format('YYYY-MM-DD 23:59:59');
        }
        return out;
    };

    convertAssetJourneyFilters = (filters) => {
        const out = { ...filters };
        // If we store them as dayjs objects, convert to string
        if (out.date_from && typeof out.date_from === 'object') {
            out.date_from = out.date_from.format('YYYY-MM-DD 00:00:00');
        }
        if (out.date_to && typeof out.date_to === 'object') {
            out.date_to = out.date_to.format('YYYY-MM-DD 23:59:59');
        }
        return out;
    };

    onExportAssetJourneyCSV = async () => {
        const { match } = this.props;
        const { asset_id } = match.params;
        const { assetJourneyTabFilter } = this.state;
        this.setState({ isExportingAssetJourneyCsv: true });

        try {
            const response = await fetchApiAuth({
                method: 'GET',
                url: '/report/get-timesheet-report-csv',
                params: {
                    asset_id: [asset_id],
                    asset_or_driver: 'assets',
                    journey_or_day: 'journeys',
                    page: 1,
                    ...this.convertAssetJourneyFilters(assetJourneyTabFilter),
                },
                responseType: 'blob',
            });

            const now = new Date();
            const dateStr = now.toISOString().split('T')[0];
            const timeStr = now.toTimeString().split(' ')[0].replace(/:/g, '-');
            const blob = new Blob([response.data], { type: 'application/csv' });
            saveAs(blob, `asset_journeys_${dateStr}_${timeStr}.csv`);
        } catch (err) {
            triggerErrorNotification(err.response ? err.response.data.message : err.message);
        } finally {
            this.setState({ isExportingAssetJourneyCsv: false });
        }
    };

    // -------------------------
    // EVENT HISTORY TAB
    // -------------------------

    onExportAssetEventCSV = async () => {
        const { match } = this.props;
        const { asset_id } = match.params;
        this.setState({ isExportingAssetEventHistoryCsv: true });

        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: `/asset/${asset_id}/events-csv-export`,
                body: {
                    ...this.convertAssetEventFilters(this.state.assetEventTabFilter),
                    page: 1,
                },
                responseType: 'blob',
            });

            const now = new Date();
            const dateStr = now.toISOString().split('T')[0];
            const timeStr = now.toTimeString().split(' ')[0].replace(/:/g, '-');
            const blob = new Blob([response.data], { type: 'application/csv' });
            saveAs(blob, `asset_events_${dateStr}_${timeStr}.csv`);
        } catch (err) {
            triggerErrorNotification(err.response ? err.response.data.message : err.message);
        } finally {
            this.setState({ isExportingAssetEventHistoryCsv: false });
        }
    };

    // -------------------------
    // VIDEO HISTORY TAB
    // -------------------------
    onVideoHistoryTabFilterChange = (values) => {
        const filters = values;
        const {
            date_to,
            date_from,
        } = filters;
        filters.date_from = date_from && date_from.format('YYYY-MM-DD 00:00:00');
        filters.date_to = date_to && date_to.format('YYYY-MM-DD 23:59:59');
        delete filters.date_range;
        filters.page = 1;
        this.setState({ videoHistoryTabFilter: filters });
        const {
            actions,
            match,
        } = this.props;
        const { asset_id } = match.params;
        const params = { asset_id, ...filters };
        actions.setAssetViewVideoFilters({
            assetId: asset_id,
            filters: params,
        });
        actions.getAssetHistoricVideoRequest(params);
    };

    onVideoHistoryTabPageChange = (page) => {
        const { videoHistoryTabFilter } = this.state;
        const {
            actions,
            match,
        } = this.props;

        videoHistoryTabFilter.page = page;
        const { asset_id } = match.params;
        this.setState({ videoHistoryTabFilter });
        const params = { 
            asset_id, 
            ...videoHistoryTabFilter, 
        };
        actions.getAssetHistoricVideoRequest(params);
    };

    onVideoHistoryTabSortChange = (pagination, filters, sorter) => {
        const {
            match,
            actions,
        } = this.props;
        const { asset_id } = match.params;
        const { videoHistoryTabFilter } = this.state;
        const orderBy = `${sorter.order === 'descend' ? '-' : ''}${sorter.field}`;
        videoHistoryTabFilter.orderBy = orderBy;
        this.setState({ videoHistoryTabFilter });

        const {
            date_from,
            date_to,
            page,
        } = videoHistoryTabFilter;
        const params = {
            assetId: asset_id,
            page,
            date_from,
            date_to,
            orderBy,
        };
        actions.getAssetHistoricVideoRequest(params);
    };

    onServiceAlertsTabPageChange = (page) => {
        const { serviceAlertsTabFilter } = this.state;
        serviceAlertsTabFilter.page = page;
        const {
            actions,
            match,
        } = this.props;
        const { asset_id } = match.params;
        this.setState({ serviceAlertsTabFilter });
        const params = { assetId: asset_id, ...serviceAlertsTabFilter };
        actions.getAssetServiceAlertsRequest(params);
    };

    onServiceAlertsTabFilterChange = (values) => {
        const filters = values;
        filters.page = 1;
        this.setState({ serviceAlertsTabFilter: filters });
        const {
            actions,
            match,
        } = this.props;
        const { asset_id } = match.params;
        const params = { assetId: asset_id, ...filters };
        actions.setAssetViewServiceAlertFilters({
            assetId: asset_id,
            filters: params,
        });
        actions.getAssetServiceAlertsRequest(params);
    };

    onServiceAlertsTabSortChange = (pagination, filters, sorter) => {
        const { serviceAlertsTabFilter } = this.state;
        const {
            actions,
            match,
        } = this.props;
        const { asset_id } = match.params;
        const params = {
            assetId: asset_id,
            orderBy: `${sorter.order === 'descend' ? '-' : ''}${sorter.field}`, ...serviceAlertsTabFilter,
        };
        actions.getAssetServiceAlertsRequest(params);
    };

    render() {
        return this.view();
    }
}

AssetView.propTypes = {
    actions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        singleAsset: state.asset.singleAsset,
        isFetching: state.asset.isFetching,
        user: state.user,
        companyUsers: state.user.companyUsers,
        driverList: state.driver.driverList,
        assetViewJourneyFilters: state.asset.assetViewJourneyFilters,
        assetViewEventFilters: state.asset.assetViewEventFilters,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                ...assetActions,
                ...driverActions,
                ...reportActions,
            },
            dispatch
        ),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AssetView);
